import { render } from "./ChildComponent.vue?vue&type=template&id=6dc97438"
import script from "./ChildComponent.vue?vue&type=script&lang=js"
export * from "./ChildComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__